// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const Icon = require('client-v2/common/containers/icons/component')
const AddToCollectionModalAnchor = require('client-v2/common/containers/lightweight-engagement/containers/add-to-collection-modal/components/anchor-smart')
const ShareModalAnchor = require('client-v2/common/containers/share-modal-v2/components/anchor-smart')
const { usePropsCallback } = require('client-v2/common/hooks/callbacks')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('SeriesFeedArticleActions')

function SeriesFeedArticleActions(props) {
  const { article, anchorId } = props
  const {
    isRatedUp,
    isRatedDown,
    handleRateUp,
    handleRateDown
  } = useArticleRating(props)
  const handleBookmark = usePropsCallback(props, 'onArticleBookmark')
  const handleMoreActions = usePropsCallback(props, 'onArticleMoreActions')
  const handleShare = usePropsCallback(props, 'onArticleShare')
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('thumbs')
      },
        tag('button', {
          'aria-label': 'Thumb up',
          className: bem.element('button'),
          onClick: handleRateUp
        },
          tag(Icon, {
            className: bem.element('thumb-up'),
            id: isRatedUp ? 'thumb-fill' : 'thumb-stroke'
          })
        ),
        tag('div', {
          className: bem.element('spacer')
        }),
        tag('button', {
          'aria-label': 'Thumb down',
          className: bem.element('button'),
          onClick: handleRateDown
        },
          tag(Icon, {
            className: bem.element('thumb-down'),
            id: isRatedDown ? 'thumb-fill' : 'thumb-stroke'
          })
        )
      ),
      tag('div', {
        className: bem.element('spacer')
      }),
      tag(AddToCollectionModalAnchor, {
        anchorId,
        placement: 'top',
        popperClassName: bem.element('bookmark-popper'),
        urlId: article['url_id']
      },
        tag('button', {
          'aria-label': 'Bookmark',
          'aria-pressed': article.isMixed,
          className: bem.element('button'),
          onClick: handleBookmark
        },
          tag(Icon, {
            id: article.isMixed ? 'bookmark-fill' : 'bookmark-stroke'
          })
        )
      ),
      tag(ShareModalAnchor, {
        anchorId,
        popperClassName: bem.element('share-button-popper'),
        portalContainer: props.portalContainer,
        contentId: props.article['url_id']
      },
        tag('button', {
          'aria-label': 'Share',
          className: bem.element('button'),
          onClick: handleShare
        },
          tag(Icon, { id: 'share-send' })
        )
      ),
      tag('button', {
        'aria-label': 'More actions',
        className: bem.element('button'),
        onClick: handleMoreActions
      },
        tag(Icon, { id: 'vertical-ellipsis' })
      )
    )
  )
}

function useArticleRating({
  article,
  pageContext,
  rating,
  onArticleRate
}) {
  const isRatedUp = rating === 'up'
  const isRatedDown = rating === 'down'
  const handleRateUp = React.useCallback(
    () => {
      const newRating = isRatedUp ? 'none' : 'up'
      onArticleRate({ article, pageContext, rating: newRating })
    },
    [ article, pageContext, isRatedUp, onArticleRate ]
  )
  const handleRateDown = React.useCallback(
    () => {
      const newRating = isRatedDown ? 'none' : 'down'
      onArticleRate({ article, pageContext, rating: newRating })
    },
    [ article, pageContext, isRatedDown, onArticleRate ]
  )
  return { isRatedUp, isRatedDown, handleRateUp, handleRateDown }
}

module.exports = SeriesFeedArticleActions
